module.exports = __webpack_public_path__ + "img/1531367495.dcabf0b5.jpg";